import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { testimonials, TESTIMONIALS_NOTE } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="border-b border-line bg-canvas" data-id="element-170" data-mp="3fzdzvmnrkjqe">
      <div className="mx-auto max-w-3xl px-4 py-9 text-center sm:px-6" data-id="element-171" data-mp="3b148ln55u3a2">
        <h2 id="testimonios" className="font-display text-lg font-extrabold uppercase text-ink sm:text-xl" data-id="element-172" data-mp="3ayqat6j3icyt">
          Lo que dicen quienes ya empezaron
        </h2>

        <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-173" data-mp="3228za26tkd2j">
          {testimonials.map((t, i) => <Reveal key={t.author} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-line bg-surface p-4 text-left" data-id="element-174" data-mp="2x2mm1sqzqwtq" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-175" data-mp="qalka1e45dvj">
                {Array.from({
              length: 5
            }).map((_, j) => <StarIcon key={j} size={12} className="fill-accent text-accent" data-id="element-176" data-mp="h559pzvzjrw1" data-mpi={j} />)}
              </div>
              <blockquote className="mt-2 text-sm leading-relaxed text-ink" data-id="element-177" data-mp="7927ku14vt93">
                “{t.quote}”
              </blockquote>
              <p className="mt-auto pt-3 text-xs font-semibold text-ink-subtle" data-id="element-178" data-mp="c8y1u1k146bg">
                {t.author} — {t.location}
              </p>
            </Reveal>)}
        </ul>

        <p className="mt-3 text-[0.7rem] italic text-ink-subtle" data-id="element-179" data-mp="14ur66fkz3t0c">
          {TESTIMONIALS_NOTE}
        </p>
      </div>
    </section>;
}